// @ts-check
// import { select } from "_temp/Attributes/_Composed"
import moment from "moment"
import React, { Component, Fragment } from "react"
// import PropTypes from "prop-types"
import Button from "../../ui/legacy/Button"
import ButtonGroup from "../../ui/legacy/ButtonGroup"
import Icon from "../../ui/legacy/Icon"
import { deviceType, query, url } from "./ContextProviders"
import AvailableProperties from "./properties/AvailableProperties"
import DefineProperty from "./properties/DefineProperty"
import PropertyValue from "./properties/PropertyValue"

/**
 * @augments {Component<BlockTypeProps, {}>}
 */
export class UserBlock extends Component {
    static attributes = []
    state = {
        is_spy: false,
    }
    renderMobile() {
        return (
            <Fragment>
                <h4>
                    <Icon name="new" style={{ width: 15 }} />
                    {this.props.config.attributes.country}'s
                </h4>
                <ButtonGroup>
                    <Button
                        icon="user-secret"
                        type="primary"
                        onClick={() => this.setState({ is_spy: true })}
                        disabled={this.state.is_spy}
                    />
                    <Button
                        icon="cutlery"
                        type="primary"
                        onClick={() => this.setState({ is_spy: false })}
                        disabled={!this.state.is_spy}
                    />
                </ButtonGroup>
            </Fragment>
        )
    }
    renderTablet() {
        return (
            <Fragment>
                <div
                    style={{
                        border: "1px solid #F1F1F1",
                        padding: 10,
                        textAlign: "center",
                    }}
                >
                    <h2>{this.props.config.attributes.country}'s Profile</h2>
                    <ButtonGroup>
                        <Button
                            type="primary"
                            onClick={() => this.setState({ is_spy: true })}
                            disabled={this.state.is_spy}
                        >
                            Turn into a russian spy
                        </Button>
                        <Button
                            type="primary"
                            onClick={() => this.setState({ is_spy: false })}
                            disabled={!this.state.is_spy}
                        >
                            Poison spy
                        </Button>
                    </ButtonGroup>
                </div>
            </Fragment>
        )
    }
    renderDesktop() {
        return (
            <Fragment>
                <h1>
                    <Icon name="new" style={{ width: 20 }} />CountryCard!{" "}
                </h1>
                <div
                    style={{
                        border: "1px solid #F1F1F1",
                        padding: 10,
                        textAlign: "center",
                    }}
                >
                    <h2>Welcome to {this.props.config.attributes.country}'s Profile!</h2>
                    <Button
                        size="large"
                        icon="user-secret"
                        type="primary"
                        onClick={() => this.setState({ is_spy: true })}
                        disabled={this.state.is_spy}
                    >
                        Turn into a spy
                    </Button>
                    <Button
                        size="large"
                        icon="cutlery"
                        type="primary"
                        onClick={() => this.setState({ is_spy: false })}
                        disabled={!this.state.is_spy}
                    >
                        Poison spy
                    </Button>
                </div>
            </Fragment>
        )
    }
    render() {
        return (
            <div
                {...this.props.utils.getRootProps({
                    style: {
                        paddingLeft: 30,
                        border: "1px solid #CCC",
                        margin: 3,
                    },
                })}
            >
                <DefineProperty name="is_spy" type="boolean" value={this.state.is_spy} />

                {this.props.renderDroppable()}
                {this.props.context.deviceType === "mobile" && this.renderMobile()}
                {this.props.context.deviceType === "tablet" && this.renderTablet()}
                {this.props.context.deviceType === "desktop" && this.renderDesktop()}

                {this.props.utils.renderChildren(this.props.childBlocks)}
            </div>
        )
    }
}

/**
 * @augments {Component<BlockTypeProps, any>}
 */
export class UsersBlock extends Component {
    static attributes = []
    state = {
        show: false,
    }
    renderMobile() {
        return (
            <Fragment>
                <Button
                    type="primary"
                    icon="clue"
                    onClick={() => this.setState(({ show }) => ({ show: !show }))}
                    disabled={!this.props.config.attributes.selectedUser}
                >
                    is there a spy?
                </Button>
                {this.state.show && (
                    <PropertyValue name={this.props.config.attributes.selectedUser}>
                        {is_spy => (
                            <div>
                                <b>Result:</b>
                                {is_spy === true && "YES"}
                                {is_spy === false && "yes, but one is dead"}
                                {is_spy === undefined && "probably"}
                            </div>
                        )}
                    </PropertyValue>
                )}
            </Fragment>
        )
    }

    render() {
        return (
            <div
                {...this.props.utils.getRootProps({
                    style: {
                        paddingLeft: 30,
                        border: "1px solid #CCC",
                        margin: 3,
                    },
                })}
            >
                {this.props.renderDroppable()}
                <div style={{ border: "1px solid #CCC" }}>Select a country (a block):</div>
                {this.props.config.attributes.selectedUser && (
                    <span> Currently selected: {this.props.config.attributes.selectedUser}</span>
                )}
                <br />
                {this.renderMobile()}
                {this.props.utils.renderChildren(this.props.childBlocks)}
            </div>
        )
    }
}

export class DateBlock extends Component {
    static attributes = [
        // <AvailableProperties>{properties => select(properties)}</AvailableProperties>,
    ]

    render() {
        const { Wrapper } = this.props
        return (
            <Wrapper {...this.props}>
                {({ attrs }) => (
                    <div style={{ border: "1px solid #CCC" }}>
                        Select a date block
                        <PropertyValue name={attrs.selectedDate}>
                            {value =>
                                value && (
                                    <span>
                                        Selected Property is of type: {this.state.type}
                                        <br />
                                        {this.state.type === "date"
                                            ? moment(value).fromNow()
                                            : value}
                                    </span>
                                )
                            }
                        </PropertyValue>
                    </div>
                )}
            </Wrapper>
        )
    }
}

/**
 * @augments {Component<BlockTypeProps, {}>}
 */
export class DefineEntityBlock extends Component {
    render() {
        const {
            utils,
            config: { attributes },
            childBlocks,
        } = this.props
        return (
            <url.Provider value={attributes.type}>
                <query.Provider value={attributes.id}>
                    <div {...utils.getRootProps()}>
                        {this.props.renderDroppable()}
                        {utils.renderChildren(childBlocks)}
                    </div>
                </query.Provider>
            </url.Provider>
        )
    }
}

/**
 * @param {BlockTypeProps} props
 */
export function TextBlock(props) {
    return <div {...props.utils.getRootProps()} children={props.renderDroppable()} />
}
/**
 * @augments {Component<BlockTypeProps, {}>}
 */
export class DeviceSelectorBlock extends Component {
    render() {
        if (this.props.context.editor.isEditing) {
            const type = this.props.config.attributes.type || this.props.context.deviceType
            return (
                <div {...this.props.utils.getRootProps()}>
                    {this.props.renderDroppable()}
                    <ButtonGroup>
                        <Button
                            onClick={() => this.props.utils.updateAttributes("type", "mobile")}
                            icon="mobile"
                            type="primary"
                            active={type === "mobile"}
                        />
                        <Button
                            onClick={() => this.props.utils.updateAttributes("type", "tablet")}
                            icon="tablet"
                            type="primary"
                            active={type === "tablet"}
                        />
                        <Button
                            onClick={() => this.props.utils.updateAttributes("type", "desktop")}
                            icon="desktop"
                            type="primary"
                            active={type === "desktop"}
                        />
                    </ButtonGroup>

                    <deviceType.Provider
                        value={type}
                        children={this.props.utils.renderChildren(this.props.childBlocks)}
                    />
                </div>
            )
        }
        return this.props.utils.renderChildren(this.props.childBlocks)
    }
}



// WEBPACK FOOTER //
// ./src/features/editor/DebugBlock.js